import { Radio as RadioBtn, withStyles } from '@material-ui/core';
import { makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles(
  (theme: Theme) => ({
    root: {
      display: 'flex',
      alignItems: 'flex-start',
      flexDirection: 'row',
      '@media (max-width: 420px)': {
        minWidth: '11rem',
      },
      minWidth: '11.5rem',
      marginLeft: 0,
      marginTop: '0.5rem',
      marginBottom: '0.6rem',
      padding: '0.6rem 5rem 0.5rem 1.2rem',
      border: `2px solid ${theme.palette.dark[400]}`,
      '&:active': {
        border: `2px solid ${theme.palette.green[800]}`,
        backgroundColor: theme.palette.green[50],
      },
      '& span': {
        ...theme.bodyStyles.body2,
        display: 'flex',
        flexDirection: 'column',
      },
      '& span:first-child': {
        ...theme.leads.lead1,
        letterSpacing: '0px',
        lineHeight: '2.8rem',
      },
      '@media (max-width: 600px)': {
        '& span:first-child': {
          ...theme.leads.lead2,
        },
        '& span': {
          ...theme.bodyStyles.body2,
          paddingTop: '0.15rem',
        },
      },
    },
    inputLabel: {
      marginBottom: '0.4rem',
    },
    unselectedRadioBtn: {
      backgroundColor: theme.palette.light[100],
    },
    selectedRadioBtn: {
      border: `2px solid ${theme.palette.green[500]}`,
      backgroundColor: theme.palette.green[50],
    },
    selectedRadioBtnMainText: {
      fontWeight: 500,
    },
    selectedRadioBtnSecondaryText: {
      margin: 0,
    },
  }),
  { index: 1 },
);

export const Radio = withStyles((theme) => ({
  root: {
    color: theme.palette.common.black,
    '&$checked': {
      color: theme.palette.green[800],
    },
  },
  checked: {},
}))(RadioBtn);
